import { render } from "./UserEditDialog.vue?vue&type=template&id=0b46e774&scoped=true"
import script from "./UserEditDialog.vue?vue&type=script&lang=js"
export * from "./UserEditDialog.vue?vue&type=script&lang=js"

import "./UserEditDialog.vue?vue&type=style&index=0&id=0b46e774&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b46e774"]])

export default __exports__